// @flow

import { createActions, handleActions } from 'redux-actions'
import { type User } from 'types/user'

/**
 * Reducer section
 */
export type State = {}

const initialState: State = {}

const actionTypes = {
  SET_USER: 'SET_USER',
}

export const actions = createActions(actionTypes.SET_USER)

type Action = {
  type: string,
  payload: Object,
}

export const reducer = handleActions(
  {
    [actionTypes.SET_USER]: (state: State, action: Action) => ({
      ...state,
      ...action.payload,
    }),
  },
  initialState,
)

// 同期型ActionCreator
export function setUser(payload: User) {
  return {
    type: actionTypes.SET_USER,
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/local/user.js